import './Footer.css';

const Footer = () => {
    return <footer>Upgrade &copy; {new Date().getFullYear()}</footer>;
}

export default Footer;
